import type { DesktopDisplayMode } from '../../types';

export const getResponsiveGridColumns = (displayMode: DesktopDisplayMode = 'cards') => {
  switch (displayMode) {
    case 'moreInformation':
      return `grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2`;
    case 'largeCards':
      return `grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3`;
    default:
      return `grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4`;
  }
};
